import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type {
  ReportDashboardLibraryComponent,
  VisualizationDataTypeUnion,
} from '@core/reports-types';
import {
  BadgeComponent,
  IconComponent,
  ResizeObserverEntryDirective,
} from '@core/user-interface-legacy';

import { VisualizationLayoutComponent } from '../visualization-layout/visualization-layout.component';
import { VisualizationRendererComponent } from '../visualization-renderer/visualization-renderer.component';
import { ReportsVisualizationTitleComponent } from '../visualization-title/visualization-title.component';

@Component({
  selector: 'reports-library-component-visualization',
  templateUrl: './library-component-visualization.component.html',
  styleUrls: ['./library-component-visualization.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BadgeComponent,
    IconComponent,
    ResizeObserverEntryDirective,
    TranslatePipe,
    VisualizationLayoutComponent,
    ReportsVisualizationTitleComponent,
    VisualizationRendererComponent,
  ],
})
export class LibraryVisualizationComponent {
  public component = input.required<ReportDashboardLibraryComponent>();
  public data = input.required<VisualizationDataTypeUnion>();
  public currColWidth = input.required<number>();
  public selected = input<boolean>(false);
}
